module.exports = __webpack_public_path__ + "static/media/c02-01-8.3d8a8d9b.png";